import axios from "axios";

export const ICD_API = "icd";

export const getAllIcds = () => {
  return axios.get(`${ICD_API}`);
}

// Legacy: /icd?search=... — se mantiene por compatibilidad
export const searchIcds = (query) => {
  return axios.get(`${ICD_API}?search=${query}`);
}

// Nuevo: /icd/search?q=... incluye specialty y REMOVE_ACCENTS
export const searchIcdsWithSpecialty = (query) => {
  return axios.get(`${ICD_API}/search`, { params: { q: query } });
}

export const getIcdSpecialties = () => {
  return axios.get(`${ICD_API}/specialties`);
}
